import { render, staticRenderFns } from "./bigTurntable_B.vue?vue&type=template&id=14c7b39d&scoped=true&"
import script from "./bigTurntable_B.vue?vue&type=script&lang=js&"
export * from "./bigTurntable_B.vue?vue&type=script&lang=js&"
import style0 from "./bigTurntable_B.vue?vue&type=style&index=0&id=14c7b39d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c7b39d",
  null
  
)

export default component.exports